/* eslint-disable react/prop-types */
import React from 'react';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import ConferenceInfoContainer from './ConferenceInfoContainer';
import { connect } from 'store/modules/base/redux';
import { getConferenceInfo } from 'store/modules/conference/functions';
import { getLargeVideoParticipant } from 'store/modules/large-video/functions';
import { WhiteLogo } from 'assets/images';
import has from 'lodash/has';

/**
 * The upper band of the meeing containing the conference name, timer and labels.
 *
 * @param {Object} props - The props of the component.
 * @returns {React$None}
 */
class ConferenceInfo extends React.PureComponent {
  /**
   * Initializes a new {@code ConferenceInfo} instance.
   *
   * @param {Props} props - The read-only React {@code Component} props with
   * which the new instance is to be initialized.
   */
  constructor(props) {
    super(props);

    this._renderAutoHide = this._renderAutoHide.bind(this);
    this._renderAlwaysVisible = this._renderAlwaysVisible.bind(this);
  }

  /**
   * Renders auto-hidden info header labels.
   *
   * @returns {void}
   */
  _renderAutoHide() {
    const { autoHide } = this.props._conferenceInfo;

    if (!autoHide || !autoHide.length) {
      return null;
    }

    return (
      <ConferenceInfoContainer
        id="autoHide"
        visible={this.props._visible}></ConferenceInfoContainer>
    );
  }

  /**
   * Renders the always visible info header labels.
   *
   * @returns {void}
   */
  _renderAlwaysVisible() {
    const {
      _conferenceInfo: { alwaysVisible },
      _business
    } = this.props;
    if (!alwaysVisible || !alwaysVisible.length) {
      return null;
    }

    return (
      <ConferenceInfoContainer id="alwaysVisible" visible={this.props.visible}>
        <WhiteLogo color="#fff" height={50} width={150} />
        {_business?.logo && <img src={_business.logo} width={100} />}
      </ConferenceInfoContainer>
    );
  }

  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement}
   */
  render() {
    const { showLabel, _userProfileOptions } = this.props;
    const style = {
      zIndex: 10,
      position: 'absolute',
      top: '6.2vh',
      height: '5vh',
      width: 'auto'
    };
    if (showLabel && _userProfileOptions?.farSideImageLabel) {
      if (has(_userProfileOptions, 'imageLabelPlacement')) {
        delete style.top;
        delete style.bottom;
        delete style.left;
        delete style.right;
        style[_userProfileOptions?.imageLabelPlacement ?? 'top'] = `${
          _userProfileOptions?.imageLabelSpacing ?? 6.2
        }vh`;
      }
      if (has(_userProfileOptions, 'imageLabelSize')) {
        style.height = `${_userProfileOptions?.imageLabelSize ?? 5}vh`;
      }
      if (has(_userProfileOptions, 'imageLabelTransparency')) {
        style.opacity =
          (_userProfileOptions?.imageLabelTransparency ?? 100) / 100;
      }
    }
    return (
      <div className="details-container">
        {this._renderAlwaysVisible()}
        {this._renderAutoHide()}
        {showLabel && _userProfileOptions?.farSideImageLabel ? (
          <img src={_userProfileOptions?.farSideImageLabel} style={style} />
        ) : null}
      </div>
    );
  }
}

/**
 * Maps (parts of) the Redux state to the associated
 * {@code Subject}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _visible: boolean,
 *     _conferenceInfo: Object
 * }}
 */
function _mapStateToProps(state) {
  const { user } = state['features/login'];
  const profiles = state['features/login'].profiles;
  const largeVideoParticipant = getLargeVideoParticipant(state);

  return {
    _visible: false,
    _conferenceInfo: getConferenceInfo(state),
    _userProfileOptions:
      profiles &&
      profiles[largeVideoParticipant?.customUserid] &&
      profiles[largeVideoParticipant?.customUserid].device?.options,
    _business: user?.device?.business
  };
}

export default React.memo(
  connect(_mapStateToProps)(withBoundary(ConferenceInfo))
);
